import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { HAS_AUTH } from '@/lib/auth'
import { useCurrentUser } from '@/lib/hooks'

interface SubscriptionGuardProps {
  children: ReactNode
}

export function SubscriptionGuard({ children }: SubscriptionGuardProps) {
  const location = useLocation()
  const { data: user, isLoading: userLoading, isError } = useCurrentUser()

  if (!HAS_AUTH) return <>{children}</>

  if (userLoading) {
    return (
      <div className="flex items-center justify-center h-full text-jarvis-muted">
        Loading…
      </div>
    )
  }
  if (isError) return <>{children}</>

  // Subscription gate: send unsubscribed users to /billing. Missing third-party
  // connections (Facebook / Stripe / etc.) do NOT block dashboard access —
  // those surfaces show empty states + "Connect X" CTAs when their data isn't
  // available, which is the right product behavior for a paying customer who
  // hasn't finished onboarding yet.
  if (!user?.jarvisEnabled && location.pathname !== '/billing') {
    return <Navigate to="/billing" replace />
  }

  return <>{children}</>
}
